import '../helpers/getClosest.js';

var megaNavTrigger = document.querySelectorAll(".has-child");
var levelOneChildren = document.querySelectorAll(".megamenu--level1 .has-child");
var header = document.querySelector("header");
var navOverlay = document.querySelector(".nav-overlay");
var i;

if(header){
// Adjust height
if (window.innerWidth > 992) {
	var megaMenuHeight = "";
	var f;
	for (f = 0; f < levelOneChildren.length; f++) {

		levelOneChildren[f].addEventListener("click", function (event) {
			var megaMenuRevealed = getClosest(event.target, '.megamenu.revealed');
			megaMenuHeight = document.querySelector(".megamenu.revealed").offsetHeight;
			var subHeight = this.nextElementSibling.offsetHeight;

			megaMenuRevealed.style.transition = "max-height .3s ease-out";
			megaMenuRevealed.style.maxHeight = subHeight + "px";
			megaMenuRevealed.style.height = subHeight + "px";
		});
	}


	document.addEventListener('click', function (event) {
		if (event.target.classList.contains('btn--back')) {
			document.querySelector(".megamenu.revealed").style.transition = "all 0.3s ease-out";
			document.querySelector(".megamenu.revealed").style.maxHeight = megaMenuHeight + "px";
			document.querySelector(".megamenu.revealed").style.height = megaMenuHeight + "px";
		}
	});
}


// Toggle menues
document.addEventListener('click', function (e) {
	if (e.target.classList.contains('mega-trigger')) {
		e.preventDefault();

		var self = e.target;
		var header = document.querySelector("header");
		var secNav = document.querySelector(".secondary-nav");

		//close other

		// toggle active class

		if (window.innerWidth > 992) {
			var navActive = document.querySelector(".haschildren.active");
			if (navActive) {
				document.querySelector(".haschildren.active").classList.remove("active");
			}
			self.parentElement.classList.add("active");
			header.classList.add("bg");
			if (secNav) {secNav.classList.add("bg");}
		}

		if (self.nextElementSibling.classList.contains("revealed")) {
			self.nextElementSibling.classList.remove("revealed");
			document.querySelector(".nav-overlay").classList.remove("open");
		} else {
			var openMega = document.querySelector(".megamenu.revealed");
			if (openMega) {
				openMega.classList.remove("revealed");					
			}
			document.querySelector(".nav-overlay").classList.add("open")
			self.nextElementSibling.classList.add("revealed");
		}

		if (!self.nextElementSibling.classList.contains("revealed")) {
			setTimeout(() => {
				header.classList.remove("bg");
				if (secNav) { secNav.classList.remove("bg"); }
			}, 400);
		}

		if (window.innerWidth < 992) {
			var secNav = document.querySelector(".secondary-nav");
			if (secNav) { secNav.classList.add("visually-hidden"); }
		}
	}
})


// Meganav subnavn triggers
var l;
if (megaNavTrigger) {
	for (l = 0; l < megaNavTrigger.length; l++) {

		megaNavTrigger[l].addEventListener('click', function (e) {
			e.preventDefault();
			var parent = this.parentNode;

			var subTrigger = this.nextElementSibling;
			if (!subTrigger.classList.contains("revealed")) {
				subTrigger.classList.add("revealed");
			} else {
				subTrigger.classList.remove("revealed");
			}
		});
	}
}

document.addEventListener('click', function (event) {
	if (event.target.classList.contains('btn--back')) {
		var parent = getClosest(event.target, '.revealed');
		parent.classList.remove("revealed");
	}
	if (event.target.classList.contains('btn--back_top') && window.innerWidth < 991) {
		var secNav = document.querySelector(".secondary-nav");
			if (secNav) { secNav.classList.remove("visually-hidden"); }
	}
	if (event.target.closest('.haschildren') === null && event.target !== document.querySelector("nav")) {
		var secNav = document.querySelector(".secondary-nav");
		var header = document.querySelector("header");
		var megaMenu = document.querySelectorAll(".megamenu");
		var megaMenuSub = document.querySelector(".megamenu__sub.revealed");
		var nav = document.querySelector(".nav-overlay");

		if (megaMenuSub) {
			megaMenuSub.classList.remove("revealed");
		}
		setTimeout(() => {
			if (secNav) { secNav.classList.remove("bg"); }
			header.classList.remove("bg");
			if (window.innerWidth > 992) {
				nav.classList.remove("open");
			}
		}, 300);

		for (i = 0; i < megaMenu.length; i++) {
			if (megaMenu[i].classList.contains("revealed")) {
				megaMenu[i].style.height = null;
				megaMenu[i].style.maxHeight = null;
				megaMenu[i].classList.remove("revealed");
			}
		}
	}
}, false);

var mainNav = document.querySelector(".main-nav");
// Safari fix on mobile
if (window.innerWidth < 992 && mainNav) {
	var allMega = document.querySelectorAll(".megamenu");	
	// Set height for meganav on mobile
	for(var i=0; i<allMega.length; i++){
		allMega[i].style.height = window.innerHeight + 'px';
	}

	// Set height for mainnav on mobile
	document.querySelector(".main-nav").style.height = window.innerHeight + 'px';
}

if(mainNav){
	window.addEventListener('resize', function(){
		if(window.innerWidth > 992){
			document.querySelector(".main-nav").style.height = 'auto';
		}else{
			document.querySelector(".main-nav").style.height = window.innerHeight + 'px';
		}
	}, true);
}
}



// WEBPACK FOOTER //
// ./scripts/components/nav.js